export default __webpack_public_path__ + "static/media/cnext-welcome-desktop-2oct25.5ad240d6.png";